export default {
  data() {
    return {
      flat_statuses: {
        registered: 5,
        occupied: 4,
        sold: 3,
        booked: 2,
        available: 1,
      },
    }
  },
}
